import { mapState } from 'vuex'
import store from '@/store/store'
export default {
  data() {
    return {}
  },
  computed: {
    ...mapState('optimization', [
      'sourceSelecting',
      'destinationSelecting',
      'markers',
      'routes',
      'isDeleteMode',
      'source',
      'destinations',
      'selectedRoute',
      'selectedMarker',
      'mrpReport',
      'endPointSelecting',
      'endPoint'
    ]),
    style() {
      return 'cursor: ' + this.cursor
    },
    cursor() {
      return this.destinationSelecting || this.sourceSelecting || this.endPointSelecting
        ? 'crosshair'
        : 'grab'
    }
  },
  methods: {
    moveMarker(marker, event) {
      store.dispatch('optimization/moveMarker', {
        new: event.target._latlng,
        old: marker.latlng
      })
    },
    removeDestination(marker) {
      var routeIndex = this.destinations.indexOf(marker)
      this.destinations.splice(routeIndex, 1)
      store.dispatch('optimization/removeRoute', routeIndex)
    },
    pickCoordinate(event, isGoogle) {
      if (!this.destinationSelecting && !this.sourceSelecting && !this.endPointSelecting) {
        return
      }
      if (this.sourceSelecting) {
        store.dispatch('optimization/setSource', {
          latlng: isGoogle
            ? {
                lat: event.latLng.lat(),
                lng: event.latLng.lng()
              }
            : event.latlng
        })
      }

      if (this.destinationSelecting) {
        store.dispatch('optimization/addDestination', {
          latlng: isGoogle
            ? {
                lat: event.latLng.lat(),
                lng: event.latLng.lng()
              }
            : event.latlng
        })
      }

      if(this.endPointSelecting) {
        store.dispatch('optimization/setEndPoint', {
          latlng: isGoogle
            ? {
                lat: event.latLng.lat(),
                lng: event.latLng.lng()
              }
            : event.latlng
        })
      }

    }
  }
}
